<form *ngIf="block && form" [formGroup]="form">
  <pl-radio
    #plRadiobox
    [label]="block.data.label || ''"
    [subLabel]="block.data.subLabel"
    [formControlName]="FormControlName.items"
    [isFormSubmitted]="courseContentService.isMainFormSubmitted()"
    [isDisabled]="isDisabled"
    [isRequired]="block.data.config.required === '1' || block.data.config.required === true"
    [minItemsDisplayed]="5"
  />
</form>
